<template>
  <div class="reservation-confirmation">
    <div class="confirmation-content">
      <h1 v-if="actionType === 'accept'">Confirmer l'acceptation</h1>
      <h1 v-else>Confirmer l'annulation</h1>
      
      <div class="button-group">
        <button 
          v-if="actionType === 'accept'"
          @click="submitAction" 
          class="btn btn-accept"
          :disabled="isLoading"
        >
          {{ isLoading ? 'Traitement...' : 'Accepter' }}
        </button>
        <button 
          v-else
          @click="submitAction" 
          class="btn btn-cancel"
          :disabled="isLoading"
        >
          {{ isLoading ? 'Traitement...' : 'Annuler la réservation' }}
        </button>
      </div>
    </div>
    <Flash :text="flashMessage" :status="flashStatus" @destroy="clearFlash"></Flash>
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';
import Flash from 'alert/Flash.vue';

export default {
  name: 'ReservationConfirmation',
  components: {
    Flash
  },
  props: {
    actionType: {
      type: String,
      required: true,
      validator: (value) => ['accept', 'cancel'].includes(value)
    },
    reservationId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      flashMessage: '',
      flashStatus: null
    };
  },
  methods: {
    async submitAction() {
      this.isLoading = true;
      const url = `/reservations/${this.reservationId}/${this.actionType}`;
      
      try {
        const response = await fetcher.post(url, {});
        
        this.flashStatus = 'success';
        if (this.actionType === 'accept') {
          this.flashMessage = 'Réservation acceptée avec succès!';
        } else {
          this.flashMessage = 'Réservation annulée avec succès!';
        }
        
        // Redirect after 2 seconds
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      } catch (error) {
        this.flashStatus = 'alert';
        // Extract error message from axios error response
        if (error.response && error.response.data) {
          this.flashMessage = error.response.data.error || error.response.data.message || 'Une erreur est survenue';
        } else {
          this.flashMessage = error.message || 'Une erreur est survenue lors du traitement';
        }
        console.error('Error:', error);
      } finally {
        this.isLoading = false;
      }
    },
    clearFlash() {
      this.flashMessage = '';
      this.flashStatus = null;
    }
  }
};
</script>

<style scoped>
.reservation-confirmation {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.confirmation-content {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  margin-bottom: 30px;
  color: #333;
  font-size: 24px;
}

.button-group {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.btn {
  padding: 12px 30px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-accept {
  background-color: #3B6152;
  color: white;
}

.btn-accept:hover:not(:disabled) {
  background-color: #2d4a3d;
  color: white;
}

.btn-cancel {
  background-color: #D56A70;
  color: white;
}

.btn-cancel:hover:not(:disabled) {
  background-color: #c45560;
  color: white;
}
</style>
